import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, VariablesDTO } from './types'

export const UPDATE_PRODUCT: TypedDocumentNode<Data, { input: VariablesDTO }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateProduct($input: UpdateWorkspaceProductStatusInput!) {
    updateWorkspaceProductStatus(input: $input) {
      workspaceProduct {
        id
        product
        status
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
